import InputSingleDate from '../../../common/datePicker/InputSingleDate'
import InputTypingDate from '../../../common/datePicker/InputTypingDate'
import { typeInputTyping } from '../../../common/datePicker/constants'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../SideBarUserManagement'
import classes from '../../index.module.scss'

export const InputDate = ({ defaultDate, value, onChange, placeholder }) => {
  return (
    <Element className={classes.date} style={{ marginLeft: 10 }}>
      <InputSingleDate
        defaultDate={defaultDate}
        onSubmit={onChange}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      >
        <Element
          className={classes.input}
          style={{ borderColor: '#E0E0E0', width: 130 }}
        >
          <InputTypingDate
            date={value}
            onChange={onChange}
            typeInput={typeInputTyping.SINGLE_DATE}
            style={{ border: 'none', outline: 'none' }}
            placeholder={placeholder}
          />
          <Icon
            className="icon-calendar"
            style={{ fontSize: 16, color: '#9C9C9C' }}
          />
        </Element>
      </InputSingleDate>
    </Element>
  )
}
